import BANK_LOGO from "client/assets/LOGO/BANK_LOGO.png";
import { ReactComponent as BackIcon } from "../../assests/icons/back.svg";
import { useNavigate } from "react-router";

export default function AuthLogoHeader({ title = "" }) {
  const navigate = useNavigate();

  return (
    <>
      <div className="back-header col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <div className="d-flex justify-content-between align-items-center h-25">
          <span
            onClick={() => navigate("/login")}
            style={{ cursor: "pointer" }}
          >
            <BackIcon height={40} />
          </span>

          <span>
            <img style={{ cursor: "pointer" ,marginRight:"30px" }} src={BANK_LOGO} alt="Bank Logo" height={40} />
          </span>
        </div>
        <span>{title}</span>
      </div>
    </>
  );
}
